module.exports = __webpack_public_path__ + "assets/img/Lifestyle Enclave.4c9437e7.png";